import ControlsElements from './Controls'
import UiElements from './Ui'
import CommonElements from './Common'
import CartElements from './Cart'
import FormsElements from './Forms'
import ProductElements from './Product'
import AuthenticationElements from './Authentication'
import FiltersElements from './Filters'
import ListElements from './List'
import PaginationElements from './Pagination'
import DeliveryElements from './Delivery'
import CheckoutElements from './Checkout'
import ProfileElements from './Profile/components'

export default function Components(Vue) {
  Vue.use(ControlsElements)
  Vue.use(UiElements)
  Vue.use(CommonElements)
  Vue.use(CartElements)
  Vue.use(FormsElements)
  Vue.use(ProductElements)
  Vue.use(AuthenticationElements)
  Vue.use(FiltersElements)
  Vue.use(ListElements)
  Vue.use(PaginationElements)
  Vue.use(DeliveryElements)
  Vue.use(CheckoutElements)
  Vue.use(ProfileElements)
}
